import {
  LegacyPortalEventGoodsInventoryStatus,
  LegacyPortalEventGoodsSalesStatus,
} from "@spwn-portal/grpc";

export type EventGoodsStatus =
  | "ON_SALE" // 販売中
  | "SOLD_OUT" // 売り切れ
  | "AFTER_SALE" // 販売期間終了
  | "BEFORE_SALE"; // 販売開始前(一般ユーザーには表示されないステータス)

export const getEventGoodsStatus = (
  salesStatus: LegacyPortalEventGoodsSalesStatus,
  inventoryStatus: LegacyPortalEventGoodsInventoryStatus
): EventGoodsStatus => {
  if (salesStatus === LegacyPortalEventGoodsSalesStatus.AFTER_SALE) {
    //販売終了が最優先
    return "AFTER_SALE";
  } else if (salesStatus === LegacyPortalEventGoodsSalesStatus.ON_SALE) {
    if (inventoryStatus === LegacyPortalEventGoodsInventoryStatus.IN_STOCK) {
      return "ON_SALE";
    } else {
      return "SOLD_OUT";
    }
  } else {
    // 一般ユーザーには表示されないステータスだがOpsで使用する場合があるため、ここで返却する
    return "BEFORE_SALE";
  }
};
